// extracted by mini-css-extract-plugin
export default {"demo":"Qh1kajZB0ldLtkuo1Pvg"};